import React, { FC, ReactElement } from "react";
import { Tooltip } from "@mui/material";

interface CustomTooltipProps {
  children: ReactElement;
  text: string;
}

const CustomTooltip: FC<CustomTooltipProps> = ({ children, text }) => {
  return (
    <Tooltip title={text} arrow>
      <span>{children}</span>
    </Tooltip>
  );
};

export default CustomTooltip;

